import React, {Component} from "react"
import {upperFirst} from "lodash"

export default class Profile extends Component {
  render() {
    return (
      <div className="sh-profile" style={{background: "grey"}}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile.js